export * from './product-category-summary.component';
export * from './product-category-summary.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/product-category/summary/index.ts